/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */

import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { FeaturesContext } from 'helpers/providers/FeaturesProvider';

import { MainForm } from 'helpers/form';
import { useImg, useText } from 'hooks';

import { ButtonStyles, WarningStyles } from '../UI/UI';

const FormBlock = () => {
  const features = useContext(FeaturesContext);
  const extendForm = features.includes('extend_form');

  return (
    <>
      <Top>{useText('form__title', true)}</Top>
      <Body>
        <MainForm
          gdprCss={gdprStyles}
          buttonCss={ButtonStyles}
          useFullName
          useCountry={extendForm}
          useAge={extendForm}
        />
        <Text>{useText('form__text', true)}</Text>
      </Body>
      <Payments>{useImg('payments.svg')}</Payments>
    </>
  );
};

const Top = styled.div`
  color: #000000;
  background-color: #ffffff;
  font-weight: 700;
  font-size: 23px;
  line-height: 28px;
  text-align: center;
  color: #000000;
  padding: 16px 16px 8px;
  border-radius: 10px 10px 0 0;
`;

const Body = styled.div`
  padding: 8px 16px;
  background-color: #ffffff;
`;

const gdprStyles = css`
  ${WarningStyles}
`;

const Text = styled.div`
  color: #6d6d6d;
  text-align: center;
  font-size: 13px !important;
  line-height: 16px;

  ${WarningStyles}
`;

const Payments = styled.div`
  background: #efefef;
  padding-top: 16px;
  padding-bottom: 17px;
  border-radius: 0 0 10px 10px;

  img {
    display: block;
    max-width: 273px;
    width: 100%;
    margin: 0 auto;
  }
`;

export default FormBlock;
